  {{#if (getGeometry entity)}}
  <tr class="gnd-infobox-geometry">
    <th>Koordinaten:</th>
    <td>
      <dl>
        <dd>{{getGeometry entity}}</dd>
      </dl>
    </td>
  </tr>
  {{/if}}  
  {{#if entity.geographicAreaCode}}
  <tr class="gnd-infobox-geographic-area-code">
    <th>Land:</th>
    <td>
      <dl>
        {{#each (arrayify entity.geographicAreaCode) as |ac|}}
        <dd>
          {{prefLabelInGraph ac.[@id] 'gnd-ac'}}
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.broaderTermPartitive}}  
  <tr class="gnd-infobox-broader-term-partitive">
    <th>Verwaltungseinheit:</th>
    <td>
      <dl>        
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>        
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.spatialAreaOfActivity}}  
  <tr class="gnd-infobox-spatial-area-of-activity">
    <th>Geografischer Bezug:</th>
    <td>
      <dl>
        {{#each (arrayify entity.spatialAreaOfActivity) as |subentity| }}
        <dd>
          <a href="{{hrefGnd subentity.[@id]}}">{{preferredName subentity}}</a>
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.placeOfBusiness }}
  <tr class="gnd-infobox-place-of-business">
    <th>Ortssitz:</th>
    <td>
      <dl>
      {{#each (arrayify entity.placeOfBusiness) as |subentity| }}
        <dd><a href="{{hrefGnd subentity.[@id]}}">{{preferredName subentity}}</a></dd>
      {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if (hasAny entity 'precedingCorporateBody' 'succeedingCorporateBody' 'temporaryNameOfTheCorporateBody' 'hierarchicalSuperiorOfTheCorporateBody')}}
  <tr class="gnd-infobox-corporate-body-relations">
    <th>Beziehung zu Organisationen:</th>
    <td>
      <dl>
        {{#each (arrayify entity.precedingCorporateBody)}}
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>
        {{/each}}
        {{#with entity.succeedingCorporateBody}}
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>
        {{/with}}
        {{#with entity.temporaryNameOfTheCorporateBody}}
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>
        {{/with}}
        {{#with entity.hierarchicalSuperiorOfTheCorporateBody}}
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>
        {{/with}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if (prop entity 'biographicalOrHistoricalInformation') }}
  <tr class="gnd-infobox-biographical-or-historical-information">
    <th>Weitere Angaben:</th>
    <td>
      <dl>
        <dd >{{ prop entity 'biographicalOrHistoricalInformation' }}</dd>
      </dl>      
    </td>
  </tr>  
  {{/if}}
  {{#if entity.dateOfEstablishment }}
  <tr class="gnd-infobox-date-of-establishment">
    <th>Gründung:</th>
    <td>
      <dl>
        <dd>{{ entity.dateOfEstablishment }}</dd>
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.dateOfTermination }}
  <tr class="gnd-infobox-date-of-termination">
    <th>Auflösungsdatum:</th>
    <td>
      <dl>
        <dd>{{ entity.dateOfTermination }}</dd>
      </dl>
    </td>
  </tr>
  {{/if}}

  {{#if entity.definition }}
  <tr class="gnd-infobox-definition">
    <th>Beschreibung:</th>
    <td>
      <dl>
        <dd>
          {{ entity.definition.[@value] }}
        </dd>
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.owl:sameAs }}
  <tr class="gnd-infobox-same-as">
    <th>Gleichwertige Konzepte:</th>
    <td>
      <dl>
          {{#each (arrayify entity.owl:sameAs) as |subentity| }}
          <dd><a href="{{hrefGnd subentity.[@id]}}">{{hrefGnd subentity.[@id]}}</a></dd>
          {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if (variantName entity) }}
  <tr class="gnd-infobox-variant-names">
    <th>Varianten:</th>
    <td>
      <dl>
        {{#each (arrayify (variantName entity)) as |name|}}
        <dd class="gnd-infobox-variant-name">{{ name }}</dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
